import { render } from "./complaintPage.vue?vue&type=template&id=97ed4628&scoped=true"
import script from "./complaintPage.vue?vue&type=script&lang=js"
export * from "./complaintPage.vue?vue&type=script&lang=js"

import "./complaintPage.vue?vue&type=style&index=0&id=97ed4628&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ed4628"]])

export default __exports__